module.exports = __webpack_public_path__ + "img/Large-Semi-Elliptical-Attachment-R-24.f589db2a.png";